import React from 'react';
import { useTheme } from '@mui/material/styles';

// 알림 아이콘 컴포넌트들
// Figma 디자인에 맞춘 SVG 아이콘

// 레벨업 아이콘
export const LevelUpIcon = ({ size = 48, opacity = 0.6, ...props }) => {
    const theme = useTheme();
    const iconColor = theme.palette.figma?.icon || '#9b96a2';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
            <g opacity={opacity}>
                <path d="M15.4957 22.4347C15.4957 21.5304 16.087 20.9043 17.0261 20.9043C17.9652 20.9043 18.5565 21.513 18.5565 22.4347V31.9652H23.6348C24.5044 31.9652 25.2174 32.4173 25.2174 33.2521C25.2174 34.0869 24.5044 34.5391 23.6348 34.5391H17.287C16.2087 34.5391 15.5131 34.1043 15.5131 32.7652V22.4695L15.4957 22.4347ZM24.4174 26.6608C24.3478 26.4347 24.2435 26.1391 24.2435 25.9826C24.2435 25.0086 24.9044 24.5739 25.5652 24.5739C26.5913 24.5739 26.8522 25.426 26.9218 25.7043L28.7478 31.826H28.7826L30.6087 25.7043C30.6783 25.426 30.9391 24.5739 31.9652 24.5739C32.6087 24.5739 33.287 25.026 33.287 25.9826C33.287 26.1565 33.2 26.4521 33.1131 26.6608L30.5565 33.7913C30.2957 34.5217 30.1218 34.7652 28.7826 34.7652C27.4435 34.7652 27.2522 34.5217 27.0087 33.7913L24.4522 26.6608H24.4174Z" fill={iconColor} />
                <path d="M44 22.2909L24 4L4 22.2909H8.67273V44H39.3273V22.2909H44Z" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
};

// 리워드 아이콘
export const RewardIcon = ({ size = 48, opacity = 0.6, ...props }) => {
    const theme = useTheme();
    const iconColor = theme.palette.figma?.icon || '#9b96a2';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
            <g opacity={opacity}>
                <circle cx="24" cy="24" r="20" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.336 14C30.684 14 32.392 15.372 32.392 20.3C32.392 25.284 30.684 26.628 25.896 26.628C24.636 26.628 23.376 26.544 22.256 26.404V33.572H18V14.252C20.324 14.028 21.864 14 25.336 14ZM22.256 23.352H25.252C27.436 23.324 28.108 22.708 28.108 20.3C28.108 17.892 27.436 17.276 25.252 17.276H22.256V23.352Z" fill={iconColor} />
            </g>
        </svg>
    );
};

// 챔피언십 아이콘
export const ChampionshipIcon = ({ size = 48, opacity = 0.6, ...props }) => {
    const theme = useTheme();
    const iconColor = theme.palette.figma?.icon || '#9b96a2';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
            <g opacity={opacity}>
                <path d="M37.6578 10.2539L40.4791 9.89307C42.0356 9.67659 43.4949 10.7349 43.7868 12.2743C44.6137 16.7241 45.0028 25.0224 36.5634 25.0224" stroke={iconColor} strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round" />
                <path d="M9.34219 10.2539L6.52092 9.89307C4.96436 9.67659 3.50509 10.7349 3.21323 12.2743C2.38631 16.7241 1.99717 25.0224 10.4366 25.0224" stroke={iconColor} strokeWidth="2" strokeMiterlimit="10" />
                <path d="M37.6793 20.2117V4H9.34503V20.2117C9.34503 27.3313 14.72 35.0764 21.7002 36.255V38.5881H20.2166C19.2681 38.5881 18.4898 39.3578 18.4898 40.2959V40.3921H15.6442C14.6957 40.3921 13.9174 41.1618 13.9174 42.0998V42.2922C13.9174 43.2303 14.6957 44 15.6442 44H31.4044C32.353 44 33.1312 43.2303 33.1312 42.2922V42.0998C33.1312 41.1618 32.353 40.3921 31.4044 40.3921H28.5588V40.2959C28.5588 39.3578 27.7806 38.5881 26.832 38.5881H25.3484V36.255C32.3043 35.0764 37.7036 27.3313 37.7036 20.2117H37.6793Z" stroke={iconColor} strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round" />
                <path d="M23.5 9.55615L26.0294 14.1022L31.1855 15.0643L27.5859 18.8406L28.2426 23.9879L23.5 21.775L18.7573 23.9879L19.414 18.8406L15.8145 15.0643L20.9706 14.1022L23.5 9.55615Z" fill={iconColor} />
            </g>
        </svg>
    );
};

// 공지사항 아이콘
export const NoticeIcon = ({ size = 48, opacity = 0.6, ...props }) => {
    const theme = useTheme();
    const iconColor = theme.palette.figma?.icon || '#9b96a2';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
            <g opacity={opacity}>
                <path d="M9.78 25.98L12.67 40.32L18.69 38.81L16.2 25.98M16.2 25.98V16.5L30.7 8V34.48L16.2 25.98ZM41.45 8L36.77 11.89M41.45 35L36.77 31.11M37.91 21.24H44.17M30.7 24.72L33.15 24.19C34 24.01 34.6 23.26 34.6 22.39V20.1C34.6 19.23 34 18.48 33.15 18.3L30.7 17.77M16.21 25.98H6.19C4.43 25.98 3 24.55 3 22.79V19.69C3 17.93 4.43 16.5 6.19 16.5H16.21V25.98Z" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
};

